










import { Component, Mixins, Emit } from "vue-property-decorator";
import OptionCardSelector from "../../system/selectors/OptionCardSelector.vue";
import { DepartmentSelectableMixin } from "./mixins";

@Component({
  components: {
    selector: OptionCardSelector,
  },
})
export default class DepartmentFinder extends Mixins(DepartmentSelectableMixin) {
  @Emit("click")
  onClicked() {}
}
